import { Routes } from '@angular/router';
import { StepIds } from '../models/motors-step/motors-step-model';
import { BoatsAndMarineDescriptionAndPhotosPageComponent } from '../pages/category-page-overrides/boats-and-marine/description-and-photos/motors-description-and-photos-page.component';
import { BoatsAndMarineListingDetailsPageComponent } from '../pages/category-page-overrides/boats-and-marine/listing-details/motors-listing-details-page.component';
import { BoatsAndMarineVehicleDetailsPageComponent } from '../pages/category-page-overrides/boats-and-marine/vehicle-details/motors-vehicle-details-page.component';
import { MotorsSummaryPageComponent } from '../pages/motors-default-pages/motors-summary-page/motors-summary-page.component';

export const boatsAndMarineRoutes: Routes = [
    {
        path: '',
        redirectTo: StepIds.vehicleDetails,
        pathMatch: 'full'
    },
    {
        path: StepIds.vehicleDetails,
        component: BoatsAndMarineVehicleDetailsPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.vehicleDetails
            }
        }
    },
    {
        path: StepIds.listingDetails,
        component: BoatsAndMarineListingDetailsPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.listingDetails
            }
        }
    },
    {
        path: StepIds.descriptionAndPhotos,
        component: BoatsAndMarineDescriptionAndPhotosPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.descriptionAndPhotos
            }
        }
    },
    {
        path: StepIds.summary,
        component: MotorsSummaryPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.summary
            }
        },
        loadChildren: () =>
            import(
                '../pages/motors-default-pages/motors-summary-page/motors-summary-page.module'
            ).then(
                (mod) => mod.MotorsSummaryPageModule
            )
    }
];
